import { Music, Library, Upload } from 'lucide-react';
import clsx from 'clsx';

type View = 'library' | 'practice';

interface HeaderProps {
  view: View;
  onViewChange: (view: View) => void;
  onUploadClick: () => void;
}

export function Header({ view, onViewChange, onUploadClick }: HeaderProps) {
  return (
    <header className="bg-gray-800 border-b border-gray-700 px-4 py-3">
      <div className="flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-2">
          <Music className="w-8 h-8 text-blue-500" />
          <h1 className="text-xl font-bold">Otoflow</h1>
        </div>

        {/* Navigation */}
        <nav className="flex items-center gap-1">
          <button
            onClick={() => onViewChange('library')}
            className={clsx(
              'flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors',
              view === 'library' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700'
            )}
          >
            <Library className="w-4 h-4" />
            Library
          </button>

          <button
            onClick={() => onViewChange('practice')}
            className={clsx(
              'flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors',
              view === 'practice' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700'
            )}
          >
            <Music className="w-4 h-4" />
            Practice
          </button>
        </nav>

        {/* Upload button */}
        <button
          onClick={onUploadClick}
          className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg font-medium transition-colors"
        >
          <Upload className="w-4 h-4" />
          Upload Score
        </button>
      </div>
    </header>
  );
}
